var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreYouSureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6497 6.29476C30.092 5.31055 29.2776 4.49617 28.2934 3.93845C25.2903 2.23668 21.4762 3.29164 19.7745 6.29476L3.93736 34.2426C3.40488 35.1823 3.125 36.2439 3.125 37.3239C3.125 40.7757 5.92322 43.5739 9.375 43.5739H41.0492C42.1293 43.5739 43.1909 43.294 44.1305 42.7616C47.1337 41.0598 48.1886 37.2457 46.4869 34.2426L30.6497 6.29476ZM22.6913 7.52872C23.6145 6.26554 25.3585 5.86716 26.7528 6.65727L27.1053 6.8898C27.4405 7.14503 27.7218 7.46635 27.9309 7.83543L43.768 35.7833L43.9294 36.1107C44.5386 37.5519 43.9842 39.2526 42.5899 40.0427C42.12 40.309 41.5892 40.4489 41.0492 40.4489H9.375L9.01056 40.4279C7.45638 40.2474 6.25 38.9265 6.25 37.3239C6.25 36.7839 6.38994 36.2531 6.65618 35.7833L22.4933 7.83543L22.6913 7.52872ZM23.4375 17.6875C23.4375 17.4114 23.6614 17.1875 23.9375 17.1875H26.0625C26.3386 17.1875 26.5625 17.4114 26.5625 17.6875V27.625C26.5625 27.9011 26.3386 28.125 26.0625 28.125H23.9375C23.6614 28.125 23.4375 27.9011 23.4375 27.625V17.6875ZM25 35.9375C26.2944 35.9375 27.3438 34.8882 27.3438 33.5938C27.3438 32.2993 26.2944 31.25 25 31.25C23.7056 31.25 22.6562 32.2993 22.6562 33.5938C22.6562 34.8882 23.7056 35.9375 25 35.9375Z",
    fill: "#C92400"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5909_9372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 45,
    height: 41
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6497 6.29476C30.092 5.31055 29.2776 4.49617 28.2934 3.93845C25.2903 2.23668 21.4762 3.29164 19.7745 6.29476L3.93736 34.2426C3.40488 35.1823 3.125 36.2439 3.125 37.3239C3.125 40.7757 5.92322 43.5739 9.375 43.5739H41.0492C42.1293 43.5739 43.1909 43.294 44.1305 42.7616C47.1337 41.0598 48.1886 37.2457 46.4869 34.2426L30.6497 6.29476ZM22.6913 7.52872C23.6145 6.26554 25.3585 5.86716 26.7528 6.65727L27.1053 6.8898C27.4405 7.14503 27.7218 7.46635 27.9309 7.83543L43.768 35.7833L43.9294 36.1107C44.5386 37.5519 43.9842 39.2526 42.5899 40.0427C42.12 40.309 41.5892 40.4489 41.0492 40.4489H9.375L9.01056 40.4279C7.45638 40.2474 6.25 38.9265 6.25 37.3239C6.25 36.7839 6.38994 36.2531 6.65618 35.7833L22.4933 7.83543L22.6913 7.52872ZM23.4375 17.6875C23.4375 17.4114 23.6614 17.1875 23.9375 17.1875H26.0625C26.3386 17.1875 26.5625 17.4114 26.5625 17.6875V27.625C26.5625 27.9011 26.3386 28.125 26.0625 28.125H23.9375C23.6614 28.125 23.4375 27.9011 23.4375 27.625V17.6875ZM25 35.9375C26.2944 35.9375 27.3438 34.8882 27.3438 33.5938C27.3438 32.2993 26.2944 31.25 25 31.25C23.7056 31.25 22.6562 32.2993 22.6562 33.5938C22.6562 34.8882 23.7056 35.9375 25 35.9375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5909_9372)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#C92400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreYouSureIcon);
export default __webpack_public_path__ + "static/media/are_you_sure_icon.d6696e0555faf03c4281c3fb238ee9f2.svg";
export { ForwardRef as ReactComponent };